import * as React from 'react';
import SecondaryButton from '../../../common/secondary-button';
import * as styles from './client-tags.module.scss';
import { TextField } from '@material-ui/core';

interface Props {
  addTagHandler: (tagName: string) => void;
}

const AddTag = ({ addTagHandler }: Props) => {
  const [inputText, setInputText] = React.useState<string>('');

  const addTag = (event?: React.FormEvent<HTMLFormElement>) => {
    event && event.preventDefault();
    if (inputText) {
      addTagHandler(inputText);
      setInputText('');
    }
  };

  return (
    <form className={styles.addTag} onSubmit={event => addTag(event)}>
      <TextField
        id="outlined-name"
        label="Tag Name"
        size="small"
        margin="none"
        variant="outlined"
        value={inputText}
        onChange={(event: any) => setInputText(event.target.value)}
      />
      <SecondaryButton text="Add" title="Add" handleClick={addTag} />
    </form>
  );
};

export default AddTag;
